var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportAndUtilityAirplane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2734.000000, -633.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transport-and-Utility/Airplane",
    transform: "translate(2734.000000, 633.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2439764,0.192389695 C28.5129777,0.641384194 26.939979,1.56437289 25.6759799,2.8283574 L20.8729837,7.63129856 L4.27499666,7.63129856 C3.11799756,7.63129856 2.00799843,8.09029293 1.18999907,8.90828291 L0,10.0982683 L10.7189916,12.6432372 L13.2889896,15.2142057 L11.501991,17.0021837 C10.9309915,17.5731768 10.4299919,18.2111689 10.0089922,18.9001605 L8.71399319,21.0231345 L4.52599646,21.0021347 C3.98699688,20.9991348 3.4579973,21.146133 2.99699766,21.4271295 L1.59399875,22.283119 L7.22299436,24.7760885 L9.71699241,30.4060195 L10.5729917,29.0030367 C10.8529915,28.5420424 11,28.0120489 10.9969914,27.4730555 L10.9759914,23.2861068 L13.0989898,21.9911226 C13.7889892,21.5701278 14.4269887,21.0691339 14.9979883,20.4981409 L16.7859869,18.7101628 L19.3559849,21.2811313 L21.9009829,32 L23.090982,30.8090146 C23.9089813,29.9920246 24.368981,28.8810382 24.368981,27.7250524 L24.368981,11.1272557 L29.1709772,6.32431457 C30.4359762,5.05933007 31.3579755,3.48734933 31.8069751,1.75537055 C32.002975,0.999379808 32.0889749,0.338387906 31.8749751,0.125390516 C31.6609753,-0.0886068621 31.0009758,-0.0036079035 30.2439764,0.192389695",
    id: 64
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportAndUtilityAirplane);
export default __webpack_public_path__ + "static/media/transport-and-utility-airplane.53db5beb.svg";
export { ForwardRef as ReactComponent };